import { ReactElement } from 'react';
import { DefaultTheme, ThemeProvider as StyledThemeProvider, useTheme } from 'styled-components';

import { defaultTheme } from '../domain';

export interface ThemeContextProviderProps {
	children: ReactElement;
	theme?: DefaultTheme;
}

export function ThemeContextProvider({ children, theme }: ThemeContextProviderProps) {
	return (
		<StyledThemeProvider theme={{ ...defaultTheme, ...theme }}>{children}</StyledThemeProvider>
	);
}

export const useThemeContext = () => {
	return useTheme();
};
